module.exports = __webpack_public_path__ + "img/download-app-left.8f1d4ad4.svg";